import { ApiClientError, UpdateCatalog } from '@raydiant/api-client-js';
import { useQueryClient } from 'react-query';
import raydiant from '../clients/raydiant';
import { keys } from '../queryClient';
import useProtectedMutation from './useProtectedMutation';

export default function useUpdateCatalog() {
  const queryClient = useQueryClient();

  const mutation = useProtectedMutation<
    void,
    ApiClientError,
    { id: string; params: UpdateCatalog }
  >(({ id, params }) => raydiant.updateCatalog(id, params), {
    onSuccess: () => {
      queryClient.invalidateQueries(keys.catalogs());
    },
  });

  return mutation;
}
